import useTranslation from 'next-translate/useTranslation';
import React, { Fragment } from 'react';
import { BatteryPower } from 'types/BatteryPower';
import { SelectItem } from '../CategoryFilter.styled';
type Props = {
  batteryPower: BatteryPower;
  selectedBatteryPower: number | null;
  setSelectedBatteryPower: React.Dispatch<React.SetStateAction<number | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export default React.memo(function BatteryFilter({
  batteryPower,

  selectedBatteryPower,
  setSelectedBatteryPower,
  setCurrent,
}: Props) {
  const { t } = useTranslation('common');

  const powerOptions = batteryPower.power.map((power) => ({
    label: power,
    value: power,
  }));

  return (
    <Fragment>
      <SelectItem
        placeholder={t('power')}
        value={powerOptions.find((power) => power.value === selectedBatteryPower) || null}
        options={powerOptions}
        isClearable
        onChange={(option: any) => {
          setSelectedBatteryPower(option?.value || null);
          setCurrent(1);
        }}
      />
    </Fragment>
  );
});
